import { render, staticRenderFns } from "./estornados.vue?vue&type=template&id=c15560ce&"
import script from "./estornados.vue?vue&type=script&lang=js&"
export * from "./estornados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports